import React from "react";
import {
    Flex,
    Box,
    HStack,
    Link,
    Image,
    IconButton,
    Menu,
    Portal, Button,
} from "@chakra-ui/react";
import {HiMenu} from "react-icons/hi";
import {Link as RouterLink} from "react-router-dom";

const NavigationBar = () => {
    const bgColor = "white";
    const hoverBg = "brand.green.100";
    const hoverColor = "brand.blue.500";

    return (
        <Box
            as="nav"
            position="sticky"
            top="0"
            zIndex="100"
            bg={bgColor}
            boxShadow="sm"
            px={6}
            py={3}
        >
            <Flex justify="space-between" align="center" maxW="1200px" mx="auto">
                <HStack spacing={6} align="center">
                    {/* Logo */}
                    <Link as={RouterLink} to="/" _hover={{textDecoration: "none"}}>
                        <Image
                            src="./CAAT_Logo_small.png"
                            alt="Computer Assisted Animal Training Logo"
                            height="50px"
                            objectFit="contain"
                        />
                    </Link>

                    {/* Main Navigation Links */}
                    <HStack spacing={4} wrap="wrap">
                        <Link
                            as={RouterLink}
                            to="/concept"
                            px={3}
                            py={1}
                            borderRadius="md"
                            fontWeight="medium"
                            _hover={{textDecoration: "none", bg: hoverBg, color: hoverColor}}
                        >
                            Concept
                        </Link>
                        <Link
                            as={RouterLink}
                            to="/plantraindoc"
                            px={3}
                            py={1}
                            borderRadius="md"
                            fontWeight="medium"
                            _hover={{textDecoration: "none", bg: hoverBg, color: hoverColor}}
                        >
                            Training App
                        </Link>
                        <Link
                            as={RouterLink}
                            to="/computer-vision"
                            px={3}
                            py={1}
                            borderRadius="md"
                            fontWeight="medium"
                            _hover={{textDecoration: "none", bg: hoverBg, color: hoverColor}}
                        >
                            Computer Vision
                        </Link>
                        <Link
                            as={RouterLink}
                            to="/ai-agents"
                            px={3}
                            py={1}
                            borderRadius="md"
                            fontWeight="medium"
                            _hover={{textDecoration: "none", bg: hoverBg, color: hoverColor}}
                        >
                            AI Plans
                        </Link>

                        {/* Dropdown for Behavior Tools */}
                        <Menu.Root>
                            <Menu.Trigger asChild>
                                <Button
                                    variant="ghost"
                                    color="black"
                                    rounded="sm"
                                    _hover={{textDecoration: "none", bg: hoverBg, color: hoverColor}}
                                >
                                    Tools
                                </Button>
                            </Menu.Trigger>
                            <Portal>
                                <Menu.Positioner>
                                    <Menu.Content>
                                        <Menu.Item value="Sensors" as={RouterLink} to="/sensors">
                                            Sensors
                                        </Menu.Item>
                                        <Menu.Item value="TrainingAids" as={RouterLink} to="/training_aids">
                                            Training Aids
                                        </Menu.Item>
                                    </Menu.Content>
                                </Menu.Positioner>
                            </Portal>
                        </Menu.Root>
                    </HStack>
                </HStack>

                {/* Hamburger menu for About and Contact */}
                <Menu.Root>
                    <Menu.Trigger asChild>
                        <IconButton variant="ghost" aria-label="Open menu">
                            <HiMenu/>
                        </IconButton>
                    </Menu.Trigger>
                    <Portal>
                        <Menu.Positioner>
                            <Menu.Content>
                                <Menu.Item value="About" as={RouterLink} to="/about"
                                            _hover={{ bg: "brand.green.100", color: "brand.blue.500" }}>
                                    About Me
                                </Menu.Item>
                                <Menu.Item value="Contact" as={RouterLink} to="/contact"
                                            _hover={{ bg: "brand.green.100", color: "brand.blue.500" }}>
                                    Contact
                                </Menu.Item>
                                <Menu.Separator />
                                <Menu.Item value="Tech" as={RouterLink} to="/tech"
                                           _hover={{ bg: "brand.green.100", color: "brand.blue.500" }}>
                                    Technology Behind CAAT
                                </Menu.Item>
                            </Menu.Content>
                        </Menu.Positioner>
                    </Portal>
                </Menu.Root>
            </Flex>
        </Box>
    );
};

export default NavigationBar;
